import { BooksDocumentsSection } from "./BooksSections";

export const AdminVerklaringenTab = () => (
    <div>
        <BooksDocumentsSection />
    </div>
);
